// extracted by mini-css-extract-plugin
export default {"authenForms":"Authentication_authenForms__3XoLC","authenButtons":"Authentication_authenButtons__vm0YJ","signAndPass":"Authentication_signAndPass__pxqoX"};